<div class="">
  <div class="row justify-content-center container-fullsize">
    <div class="col-12 col-md-8 col-lg-6">
      <div class="card shadow border-0 my-3">
        <div class="card-header">
          <h3 class="text-center text-muted my-1">
            Redefinir senha
          </h3>
        </div>
        <div class="card-body px-lg-3 py-lg-3">
          <div class="text-center text-muted mb-4">
            <h5 class="mb-2">Entre com seus dados</h5>
          </div>
          <form role="form" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
            <div class="form-group my-3">
              <div class="input-group input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text"> <i class="fa fa-user" aria-hidden="true"></i></span>
                </div>
                <input class="form-control ext-input p-4" placeholder="Login" type="text" formControlName="login">
              </div>
              <span class="alert alert-danger m-2 p-1"
                *ngIf="!formGroup.get('login').valid && formGroup.get('login').touched">
                <small>Informe os dados corretamente para o login</small>
                <i class="fas fa-exclamation ml-2"></i>
              </span>
            </div>

            <div class="form-group my-3">
              <div class="input-group input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text"> <i class="fa fa-key" aria-hidden="true"></i></span>
                </div>
                <input class="form-control ext-input p-4" placeholder="Senha" type="password" maxlength="20"
                  formControlName="senha">
              </div>

              <span class="alert alert-danger m-2 p-1"
                *ngIf="!formGroup.get('senha').valid && formGroup.get('senha').touched">
                <small>Senha é obrigatória</small>
                <i class="fas fa-exclamation ml-2"></i>
              </span>
            </div>

            <div class="form-group my-3">
              <div class="input-group input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text"> <i class="fa fa-key" aria-hidden="true"></i></span>
                </div>
                <input class="form-control ext-input p-4" placeholder="Confirmar senha" type="password" maxlength="20"
                  formControlName="confirmaSenha">
              </div>
              <span class="alert alert-danger m-2 p-1"
                *ngIf="formGroup.get('confirmaSenha').hasError('required') && formGroup.get('confirmaSenha').touched">
                <small>Confirmar senha é obrigatório</small>
                <i class="fas fa-exclamation ml-2"></i>
              </span>
              <span class="alert alert-danger m-2 p-1"
                *ngIf="!formGroup.get('confirmaSenha').hasError('required') && formGroup.errors?.notMatch && formGroup.get('confirmaSenha').touched">
                <small>Senhas não coincidem</small>
                <i class="fas fa-exclamation ml-2"></i>
              </span>
            </div>

            <div class="form-group my-3">
              <div class="input-group input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text"> <i class="fa fa-asterisk" aria-hidden="true"></i></span>
                </div>
                <input class="form-control ext-input p-4" placeholder="{{labelAuth1}}" type="text" formControlName="auth1">
              </div>
              <span class="alert alert-danger m-2 p-1"
                *ngIf="!formGroup.get('auth1').valid && formGroup.get('auth1').touched">
                <small>Autenticação é obrigatória</small>
                <i class="fas fa-exclamation ml-2"></i>
              </span>
            </div>

            <div class="form-group my-3">
              <div class="input-group input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text"> <i class="fa fa-asterisk" aria-hidden="true"></i></span>
                </div>
                <input class="form-control ext-input p-4" placeholder="{{labelAuth2}}" type="text" formControlName="auth2">
              </div>
              <span class="alert alert-danger m-2 p-1"
                *ngIf="!formGroup.get('auth2').valid && formGroup.get('auth2').touched">
                <small>Autenticação é obrigatória</small>
                <i class="fas fa-exclamation ml-2"></i>
              </span>
            </div>

            <div class="text-center mt-5">
              <button type="submit" class="btn btn-outline-info btn-lg btn-block" [disabled]="!formGroup.valid">
                Confirmar
                <i class="fas fa-paper-plane ml-2"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>